module.exports = __webpack_public_path__ + "media/common/images/badges/gray/mas_jiskru-8e57a307f10c7beb4779f56cffb83269.svg";